"use strict";

import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Joi, Validation } from 'react-validation-decorator';
const examList = [
  {
    "label": "GMAT",
    "value": "GMAT"
  },
  {
    "label": "GRE",
    "value": "GRE"
  },
  {
    "label": "TOEFL",
    "value": "TOEFL"
  },
  {
    "label": "ACT",
    "value": "ACT"
  },
  {
    "label": "SAT",
    "value": "SAT"
  }
];
class TalkToMentorForm extends React.Component {
  constructor() {
    super();
    this.state = {
      firstName: '',
      lastName: '',
      email: '',
      exams: [{ exam: 'GRE', score: '' }],
      questions: []
    };

    this._handleInputChange = this._handleInputChange.bind(this);
  };

  validationSchema = Joi.object().keys({
    firstName: Joi.string().required().label('First Name'),
    lastName: Joi.string().required().label('Last Name'),
    email: Joi.string().email().lowercase().required().label('Email'),
    exams: Joi.array().optional(),
  });

  render() {
    let { exams } = this.state;
    return (
      <form name="talkToMentorForm" noValidate >
        <Row>
        <Col md={12}>
            <div className={this.getValidationClassName('email')}>
              <label>Email</label>
              <input type='email' className='form-control'
                value={this.state.email}
                placeholder="Enter Email..."
                onChange={this._handleInputChange.bind(this, 'email')} />
              {this.renderValidationMessages('email')}
            </div>

          </Col>
          <Col md={12}>
            <div className={this.getValidationClassName('firstName')}>
              <label>First Name</label>
              <input type='text' className='form-control'
                value={this.state.firstName}
                placeholder="Enter First Name..."
                onChange={this._handleInputChange.bind(this, 'firstName')} />
              {this.renderValidationMessages('firstName')}
            </div>
          </Col>
          <Col md={12}>
            <div className={this.getValidationClassName('lastName')}>
              <label>Last Name</label>
              <input type='text' className='form-control'
                value={this.state.lastName}
                placeholder="Enter Last Name..."
                onChange={this._handleInputChange.bind(this, 'lastName')} />
              {this.renderValidationMessages('lastName')}
            </div>
          </Col>


          {exams.map((e, idx) => {
            return (<Col md={12} key={`exam${idx}`}>
              <div className={this.getValidationClassName('exams')}>
                <label>Exams {idx>0 && <i title={'Delete Question'} style={{cursor:'pointer'}} className="fa fa-trash text-danger" onClick={() => {
                let exams = this.state.exams;
                exams.splice(idx,1);
                this.setState({exams}, () => {
                  this.validate('exams');
                  this._isFormValid();
                })
              }} ></i> }</label>
                <select style={{marginBottom:'10px'}} className="form-control" value={e.exam}
                  onChange={(event) => {
                    let exams = this.state.exams;
                    exams[idx].exam = event.target.value;
                    this.setState({exams}, () => {
                      this.validate('exams');
                      this._isFormValid();
                    })
                  }}>
                  {
                    examList.map((d, idx) => {
                      return (<option value={d.value} key={`${idx}opt`}>{d.label}</option>);
                    })
                  }
                </select>
                <input type='number' className='form-control'
                  value={e.score}
                  placeholder="score"
                  onChange={(event) => {
                    let exams = this.state.exams;
                    exams[idx].score =  event.target.value;
                    this.setState({exams}, () => {
                      this.validate('exams');
                      this._isFormValid();
                    })
                  }} />
                {this.renderValidationMessages('exams')}
              </div>
            </Col>)
          })
          
        }
        <Col md={12}>
        <button style={{marginBottom:'10px'}} type='button' className='btn btn-default' onClick={(e)=>{
          let exams = this.state.exams;
          exams.push({exam:'GRE',score:''});
          this.setState({exams}, () => {
            this.validate('exams');
            this._isFormValid();
          })
        }}>Add exam</button>
        </Col>
        </Row>
      </form>
    );
  };

  _handleInputChange(formInput, event) {
    let value = event.target.value;
    this.setState(state => {
      state[formInput] = value;
    }, () => {
      this.validate(formInput);
      this._isFormValid();
    });
  };

  _isFormValid() {
    this.props.isValid(!this.state.validation.errors.length);
  };

  getModel() {
    return this.state.validation.value;
  };
}

export default Validation(TalkToMentorForm);
